<template>
  <section
    class="bg-white rounded border border-th-border-light mb-4 last:mb-0 p-6 uz:rounded-lg uz:border-th-border uz:shadow-[0_2px_6px] uz:shadow-black/[.08]"
  >
    <!-- Header -->
    <header
      v-if="
        $slots.title || title || $slots.subtitle || subtitle || $slots.actions
      "
      :class="{
        'mb-4': !collapsed
      }"
    >
      <div
        class="flex items-center justify-end gap-2"
        :class="{
          'cursor-pointer': collapsable
        }"
        @click="onHeaderClick"
      >
        <!-- Title -->
        <h3
          v-if="$slots.title || title"
          class="my-0 text-[#253950] font-bold text-md text-left mr-auto flex-1"
        >
          <span class="align-middle">
            <slot name="title">
              {{ title }}
            </slot>
          </span>

          <!-- Tooltip -->
          <th-popover
            v-if="info"
            ref="popoverRef"
            :text="info"
            placement="top"
            class="ml-1 inline-block align-middle"
          />
        </h3>

        <!-- Actions -->
        <div
          v-if="$slots.actions"
          ref="actionsRef"
          class="items-center gap-2"
          :class="collapsed ? 'hidden' : 'flex'"
        >
          <slot name="actions" />
        </div>

        <el-button
          v-if="collapsable"
          :title="
            collapsed
              ? $t('components.th_wrapper.expand')
              : $t('components.th_wrapper.collapse')
          "
          class="el-button--text-icon"
          size="default"
          text
        >
          <arrow-down-icon
            class="transform transition-all duration-300"
            :class="{ '-rotate-180': !collapsed }"
          />
        </el-button>
      </div>

      <!-- Subtitle -->
      <p
        v-show="!collapsed"
        v-if="$slots.subtitle || subtitle"
        class="th-description-text"
      >
        <slot name="subtitle">
          {{ subtitle }}
        </slot>
      </p>
    </header>

    <div v-show="!collapsed" class="relative">
      <slot />
    </div>
  </section>
</template>

<script>
import { ArrowDownIcon } from '@shared/assets/icons'

export default {
  name: 'THWrapper',

  components: {
    ArrowDownIcon
  },

  props: {
    title: {
      type: String,
      required: false,
      default: undefined
    },
    subtitle: {
      type: String,
      required: false,
      default: undefined
    },
    info: {
      type: String,
      required: false,
      default: null
    },
    collapsable: {
      type: Boolean,
      default: false
    },
    collapsedByDefault: {
      type: Boolean,
      default: false
    }
  },

  expose: ['expand'],

  data() {
    return {
      collapsed: this.collapsable && this.collapsedByDefault
    }
  },

  methods: {
    /**
     * We want to toggle the section if the user clicked on anything in the header that
     * is not the tooltip or any custom actions provided in the slot.
     */
    onHeaderClick(event) {
      if (!this.collapsable) {
        return
      }

      const { target } = event

      const popoverContainer = this.$refs.popoverRef?.$el
      const actionsContainer = this.$refs.actionsRef

      if (
        actionsContainer?.contains(target) ||
        popoverContainer?.contains(target)
      ) {
        return
      }

      this.toggleCollapse()
    },
    toggleCollapse() {
      this.collapsed = !this.collapsed
      this.$emit('collapsed-changed', this.collapsed)
    },
    expand() {
      if (!this.collapsed) return
      this.collapsed = false
      this.$emit('collapsed-changed', this.collapsed)
    }
  }
}
</script>
